export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY'
export const SET_SELECTED_CATEGORIES = 'SET_SELECTED_CATEGORIES'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_AVAILABLE_CATEGORIES = 'GET_AVAILABLE_CATEGORIES'
export const SET_AVAILABLE_CATEGORIES = 'SET_AVAILABLE_CATEGORIES'
export const SET_CATEGORIES_LOADING = 'SET_CATEGORIES_LOADING'
export const SET_PRODUCT_IDS_LOADING = 'SET_PRODUCT_IDS_LOADING'
export const GET_PRODUCT_IDS = 'GET_PRODUCT_IDS'
export const SET_PRODUCT_IDS = 'SET_PRODUCT_IDS'